const safeLower = (value) => (value == null ? '' : String(value)).toLowerCase();

export const getSiteDomain = () => {
  if (typeof window === 'undefined') return '';
  const hostname = safeLower(window.location.hostname).replace(/^www\./, '');
  return hostname;
};

export const getSiteNameFromDomain = () => {
  const hostname = getSiteDomain();
  if (!hostname) return '';

  // Strip common TLD parts to get the base domain label.
  const tldParts = [
    'com',
    'in',
    'live',
    'net',
    'org',
    'co',
    'io',
    'app',
    'dev',
    'cloud',
    'vip',
  ];

  const segs = hostname.split('.').filter(Boolean);
  if (segs.length === 1) return segs[0];

  // Remove trailing TLD segments (e.g., .com, .live).
  while (segs.length > 1 && tldParts.includes(segs[segs.length - 1])) {
    segs.pop();
  }

  // If subdomain exists (e.g., m.example.com), pick the last remaining label.
  return segs[segs.length - 1] || '';
};
